module.exports = __webpack_public_path__ + "static/img/son18_active.95d6580c.png";